<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 82 100">
    <g :fill="iconColor" fill-rule="evenodd">
      <path
        d="M51.19 70.4c.979.879 2.208 1.318 3.686 1.318 1.767 0 3.245-.447 4.434-1.342v4.264c-1.382.702-2.924 1.054-4.627 1.054-2.699 0-4.94-.815-6.723-2.443-1.783-1.63-2.675-3.72-2.675-6.276 0-2.554.883-4.646 2.65-6.275 1.784-1.628 4.025-2.443 6.724-2.443 1.606 0 3.06.32 4.362.958v4.24a8.05 8.05 0 0 0-4.314-1.222c-1.413 0-2.594.447-3.542 1.341-.948.895-1.422 2.028-1.422 3.401 0 1.406.482 2.547 1.446 3.425zm-25.255-3.425c0-2.426.843-4.486 2.53-6.179 1.687-1.692 3.807-2.539 6.362-2.539 2.554 0 4.675.847 6.362 2.54 1.687 1.692 2.53 3.752 2.53 6.178 0 2.428-.843 4.487-2.53 6.18-1.687 1.692-3.808 2.539-6.362 2.539-2.555 0-4.675-.847-6.362-2.54-1.687-1.692-2.53-3.751-2.53-6.179zm45.272 26.507H16.07c-2.287 0-4.148-1.85-4.148-4.125v-4.77h51.4c2.384 0 4.316-1.918 4.316-4.288v-26.01c0-2.37-1.932-4.29-4.315-4.29H11.922V10.644c0-2.269 1.861-4.119 4.148-4.119l37.957-.04V20.43c0 4.073 3.325 7.38 7.426 7.38l13.744-.039.155 61.586c0 2.275-1.858 4.125-4.145 4.125zM8.32 75.358V58.593h6.723c2.731 0 4.973.782 6.724 2.347 1.735 1.565 2.602 3.577 2.602 6.035 0 2.491-.867 4.512-2.602 6.06-1.72 1.55-3.96 2.323-6.724 2.323H8.32zM56.481 0H16.07C10.166 0 5.36 4.779 5.36 10.643V50H4.316C1.932 50 0 51.919 0 54.289v26.01c0 2.37 1.932 4.288 4.315 4.288h1.046v4.77C5.36 95.227 10.166 100 16.07 100h55.137c5.901 0 10.707-4.773 10.707-10.643V25.19L56.48 0z"
      />
      <path
        d="M37.984 70.376c.85-.894 1.277-2.027 1.277-3.4 0-1.374-.426-2.507-1.277-3.402-.852-.894-1.904-1.34-3.157-1.34-1.27 0-2.33.446-3.181 1.34-.836.879-1.253 2.012-1.253 3.401 0 1.39.417 2.523 1.253 3.401.851.895 1.911 1.342 3.18 1.342 1.254 0 2.306-.447 3.158-1.342M19.886 66.975c0-1.468-.45-2.602-1.35-3.4-.9-.799-2.168-1.198-3.807-1.198h-2.072v9.197h2.072c1.639 0 2.908-.399 3.808-1.198.9-.798 1.35-1.931 1.35-3.4"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'icon-doc',
    props: {
      width: {
        type: [Number, String],
        default: 82
      },
      height: {
        type: [Number, String],
        default: 100
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      }
    }
  };
</script>
